module.exports = __webpack_public_path__ + "static/media/lpi04.0a92f182.jpg";